import { useTranslation } from "react-i18next";
import { DialogTitle } from "../../molecules/DialogTitle/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import type { SystemInfoDialogProps } from "./SystemInfoDialog.types";
import useGetSystemInfo from "@/src/lib/useGetVersionInfo/useGetVersionInfo";
import FormatGitInfo from "../FormatGitInfo/FormatGitInfo";
import { Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SystemInfoDialog = ({ open, onClose }: SystemInfoDialogProps) => {
    const { t } = useTranslation("common", {
        keyPrefix: "system-info-dialog",
    });

    const {
        frontEndBuildTime,
        frontEndCommitHash,
        frontEndCommitTime,
        frontEndGitBranch,
        gitServiceInfo,
        backEndInfo,
    } = useGetSystemInfo();

    const handleCloseDialog = () => {
        onClose();
    };

    return (
        <Dialog
            onClose={handleCloseDialog}
            open={open}
            maxWidth={"sm"}
            fullWidth
            data-testid="result"
        >
            <DialogTitle>
                <Typography component="span" variant="h2">
                    {t("title")}
                </Typography>
                <IconButton color="inherit" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack py={2} spacing={2}>
                    <FormatGitInfo title={t("backend")} gitInfo={backEndInfo} />

                    <FormatGitInfo
                        title={t("git-service")}
                        gitInfo={gitServiceInfo}
                    />

                    <FormatGitInfo
                        title={t("frontend")}
                        gitInfo={{
                            git: {
                                commit: {
                                    id: {
                                        full: frontEndCommitHash,
                                    },
                                    time: frontEndCommitTime,
                                },
                                build: {
                                    date: frontEndBuildTime,
                                },
                                branch: frontEndGitBranch || "develop",
                            },
                        }}
                    />
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseDialog}>{t("ok")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SystemInfoDialog;
